<swal #currentSwal title="Operación" text="Operación realizada" icon="info"></swal>
<swal #notesSwal title="Operación" text="Operación realizada" icon="info"></swal>

<!-- <h1>{{fileIdValue ? fileIdValue: 'Sin id por ruta'}}</h1> -->
<ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }" [template]="customLoadingTemplate"></ngx-loading>
<ng-template #customLoadingTemplate></ng-template>
<div class="app-content content">
	<div class="content-wrapper">
		<div class="content-header row mb-1"></div>
		<div class="content-detached">
			<div class="content-body">
				<!-- insertar barra de busqueda -->
				<app-search-bar [criterioPrincipal]="configLocal.barraBusqueda.criterioPrincipal" [config]="configLocal.barraBusqueda" [nombreCampoDatePicker]="configLocal.barraBusqueda.nombreCampoDatePicker" [useAccordionMode]="true" [useInlineSearchButton]="true" [extraLengthGenericInput]="true" (busqueda)="searchElementsByFilter($event)"></app-search-bar>
				<section class="row">
					<div class="col-12">
						<div class="card card-custom">
							<div class="card-header">
								<h4 class="card-title">Cesiones Emitidas</h4>
								<div class="card-toolbar">
									<!-- insertar botonera -->
									<!-- <button class="btn btn-success" (click)="openAddDteFileModal(loadFileModal)">
                                        <i class="flaticon-upload"></i>
                                        <span>{{configLocal.table.add}}</span> 
                                    </button> -->
								</div>
							</div>
							<div class="card-head">
								<div class="heading-elements mt-0">
									<button class="buttonMantenedor btn btn-warning float-right mr-5 mt-5 btn-export" data-gtm-id="exportar" data-gtm-group="cesiones" (click)="exportToExcel()" ngbTooltip="Utilice el filtro de búsqueda para acotar el rango a exportar" *ngIf="permissions.getPermission('45-10-10').asignado">
										<i class="flaticon-download-1"></i>
										Exportar
									</button>

									<div ngbDropdown class="btn-descargar">
										<button ngbDropdownToggle id="dropdownDescargas" class="btn btn-primary float-right mr-5 mt-5" *ngIf="permissions.getPermission('45-10-12').asignado">
											<i class="flaticon-download"></i>
											Descarga Documentos
										</button>
										<div ngbDropdownMenu aria-labelledby="dropdownDescargas">
											<!-- <button ngbDropdownItem (click)="multipleDocumentDownload('pdf')">Descarga PDF</button> -->
											<button class="buttonMantenedor" data-gtm-id="descarga-xml" data-gtm-group="cesiones" ngbDropdownItem (click)="multipleDocumentDownload('xml')">Descarga XML</button>
										</div>
									</div>
								</div>
							</div>
							<!-- <div class="col-1" >
                                <ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" change="setPageSize()">
                                   <option *ngFor="let option of page.pageSizes" [value]="option" ></option>
                                </ng-select>
                           </div> -->
							<div class="card-content">
								<div class="card-body">
									<!-- inicion seccion botones agregar y exportar -->
									<!-- <app-exportacion-datos [dataArray]="rowsMantenedor" [exportCriteria]="criteriosEnBase"></app-exportacion-datos> -->

									<!-- fin seccion botones -->

									<!-- seccion tabla -->
									<ngx-datatable
										#table
										class="material mobile-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="50"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										(sort)="utilities.onSortTable(table, page)"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
										[externalSorting]="false"
										[sortType]="SortType.multi"
									>
										<ngx-datatable-column [width]="40" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
											<ng-template ngx-datatable-header-template let-value="value">
												<input type="checkbox" class="customCheckbox" [checked]="selectedAllItemsInPage[page.pageNumber]" (change)="selectAll($event)" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
												<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="folio" [flexGrow]="1" [sortable]="true" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Factura N°</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.folio }}</span></ng-template
											>
										</ngx-datatable-column>
										<!-- <ngx-datatable-column name="personaAutorizada" [flexGrow]="2" [sortable]="false" [resizeable]="false">
                                        <ng-template let-column="column" ngx-datatable-header-template>
                                            <span class="text-table-alignment">Rut</span>
                                        </ng-template>
                                        <ng-template ngx-datatable-cell-template let-row="row"><span class="text-table-alignment">{{row.rutPersonaAutorizadaDv?row.rutPersonaAutorizadaDv:"No disponible" }}</span></ng-template>
                                    </ngx-datatable-column> -->
										<ngx-datatable-column name="nombrePersonaAutorizada" [flexGrow]="3" [sortable]="false" [resizeable]="false" [cellClass]="'text-table-alignment'" [headerClass]="'text-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Persona Autorizada</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment">{{
													row.nombrePersonaAutorizada
														? row.nombrePersonaAutorizada
														: "No
                                                    disponible"
												}}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="fechaEmision" [flexGrow]="1.5" [sortable]="true" [resizeable]="false" [cellClass]="'date-table-alignment'" [headerClass]="'date-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="date-table-alignment">Fecha</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="date-table-alignment">{{ row.fechaEmision | date : "dd/MM/yyyy" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column name="montoTotal" [flexGrow]="2" [sortable]="true" [resizeable]="false" [cellClass]="'number-table-alignment'" [headerClass]="'number-table-alignment'">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="number-table-alignment">Monto Total</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="number-table-alignment">{{ row.montoTotal | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span></ng-template
											>
										</ngx-datatable-column>
										<ngx-datatable-column [cellTemplate]="semaforo" [sortable]="false" name="Estado" [flexGrow]="1.5" [resizeable]="false"></ngx-datatable-column>
										<ngx-datatable-column name="Acciones" [flexGrow]="3" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<a [routerLink]="" ngbTooltip="Descargar XML" class="success edit mr-1 mrless" (click)="downloadXml(row)" *ngIf="permissions.getPermission('45-10-14').asignado">
													<div class="icon-circle bg-warning text-center align-middle pt-file-button">
														<fa-icon icon="file-code" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" ngbTooltip="Trazabilidad" class="primary edit mr-1 mrless" id="mantenedor-cesion.component_Trazabilidad" (click)="openTraceShowModal(tracesModal, row)" *ngIf="permissions.getPermission('45-10-16').asignado">
													<div class="icon-circle bg-info text-center align-middle pt-list-button">
														<fa-icon icon="list-alt" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" ngbTooltip="Detalles" class="primary edit mr-1 mrless" id="mantenedor-cesion.component_Detalles" (click)="detailOpenModal(dteDetailModal, row)" *ngIf="permissions.getPermission('45-10-18').asignado">
													<div class="icon-circle bg-warning text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
												<a [routerLink]="" title="Descarga PDF DTE" ngbTooltip="Descarga PDF DTE" class="success edit mr-1 mrless" (click)="downloadPDF(row)" *ngIf="permissions.getPermission('45-10-20').asignado">
													<!-- <span  aria-label="Descarga PDF" [inlineSVG]="'./assets/media/svg/files/pdf.svg'" cacheSVG="true" class="svg-icon svg-icon-3x svg-icon-success"></span> -->
													<div class="icon-circle bg-danger text-center align-middle pt-file-button">
														<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
                <a [routerLink]="" ngbTooltip="Reenviar Cesion al SII" class="primary edit mr-1 mrless" id="mantenedor-cesion.component_Reenviar_Cesion_al_SII" (click)="resendCesion(row)" *ngIf="permissions.getPermission('45-10-22').asignado && (row.estado == 5 || row.estado == 4)">
													<div class="icon-circle bg-info text-center align-middle pt-info-button">
														<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
													</div>
												</a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="col-auto">Elementos por página</div>
												<div class="mr-5">
													<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="datatable-footer">
														<option *ngFor="let option of page.pageSizes" [value]="option"></option>
													</ng-select>
												</div>
												<div class="ml-5 col-auto divisor-footer">
													<div class="page-count">{{ rowCount }} Elementos totales</div>
												</div>
												<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="table.onFooterPage($event)"> </datatable-pager>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<!-- fin seccion tabla seccion tabla -->

									<!-- tabla movil -->
									<ngx-datatable
										#tableMobile
										*ngIf="componentStarted"
										class="material desktop-hidden"
										[rows]="rowsMantenedor"
										[columnMode]="'flex'"
										[headerHeight]="50"
										[footerHeight]="70"
										[rowHeight]="70"
										fxFlex="auto"
										[perfectScrollbar]="configScroll"
										[selectionType]="'checkbox'"
										[selected]="selected"
										(selected)="onSelect($event)"
										[rowIdentity]="getId"
										[externalPaging]="true"
										[count]="page.totalElements"
										[offset]="page.pageNumber"
										[limit]="page.pageSize"
										(page)="setPage($event)"
										[scrollbarH]="true"
										[messages]="{ emptyMessage: 'Sin datos para mostrar' | translate, totalMessage: 'Elementos totales' | translate, selectedMessage: false }"
									>
										<!-- Row Detail Template -->
										<ngx-datatable-row-detail [rowHeight]="70" #myDetailRow>
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
												<div class="text-wrap">
													Tipo Documento: {{ row.nombreTipoDte }} , Persona Autorizada:
													{{
														row.nombrePersonaAutorizada
															? row.nombrePersonaAutorizada
															: "No
                                                    disponible"
													}}, Folio: {{ row.folio }} , Monto: {{ row.montoTotal | currency : "$ " : "symbol" : "1.0-0" : "es" }} , {{ row.fechaEmision | date : "dd/MM/yyyy" }}
												</div>
											</ng-template>
										</ngx-datatable-row-detail>
										<!--CheckBox
										<ngx-datatable-column [width]="30" [sortable]="false" [canAutoResize]="false" [draggable]="false" [resizeable]="false">
											<ng-template ngx-datatable-header-template let-value="value">
												<input type="checkbox" class="customCheckbox" [checked]="selectedAllItemsInPage[page.pageNumber]" (change)="selectAll($event)" />
											</ng-template>
											<ng-template ngx-datatable-cell-template let-value="value" let-isSelected="isSelected" let-onCheckboxChangeFn="onCheckboxChangeFn">
												<input type="checkbox" class="customCheckbox" [checked]="isSelected" (change)="onCheckboxChangeFn($event)" />
											</ng-template>
										</ngx-datatable-column>-->
										<ngx-datatable-column [width]="30" [resizeable]="false" [sortable]="false" [draggable]="false" [canAutoResize]="false">
											<ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
												<a [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded" title="Expand/Collapse Row" (click)="toggleExpandRow(row)" class="desktop-hidden"> </a>
											</ng-template>
										</ngx-datatable-column>
										<ngx-datatable-column name="Razón Social" [flexGrow]="3.5" [sortable]="false" [resizeable]="false">
											<ng-template let-column="column" ngx-datatable-header-template>
												<span class="text-table-alignment">Documento</span>
											</ng-template>
											<ng-template ngx-datatable-cell-template let-row="row"
												><span class="text-table-alignment"> Folio: {{ row.folio }}</span>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-column name="Acciones" [flexGrow]="5" [sortable]="false" [resizeable]="false">
											<ng-template ngx-datatable-cell-template let-row="row">
												<div class="action-container">
													<div class="main-action-button" (click)="toggleActions(row)" *ngIf="!row.showActions">
														<fa-icon [icon]="row.showActions ? 'minus' : 'list'"></fa-icon>
													</div>

													<div class="action-buttons action-buttons-client" [ngClass]="{ show: row.showActions }">
														<a [routerLink]="" ngbTooltip="Descargar XML" class="success edit mr-1 mrless" (click)="downloadXml(row)" *ngIf="permissions.getPermission('45-10-14').asignado">
															<div class="icon-circle bg-warning text-center align-middle pt-file-button">
																<fa-icon icon="file-code" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" ngbTooltip="Trazabilidad" class="primary edit mr-1 mrless" id="mantenedor-cesion.component_Trazabilidad" (click)="openTraceShowModal(tracesModal, row)" *ngIf="permissions.getPermission('45-10-16').asignado">
															<div class="icon-circle bg-info text-center align-middle pt-list-button">
																<fa-icon icon="list-alt" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" ngbTooltip="Detalles" class="primary edit mr-1 mrless" id="mantenedor-cesion.component_Detalles" (click)="detailOpenModal(dteDetailModal, row)" *ngIf="permissions.getPermission('45-10-18').asignado">
															<div class="icon-circle bg-warning text-center align-middle pt-info-button">
																<fa-icon icon="info-circle" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
														<a [routerLink]="" title="Descarga PDF DTE" ngbTooltip="Descarga PDF DTE" class="success edit mr-1 mrless" (click)="downloadPDF(row)" *ngIf="permissions.getPermission('45-10-20').asignado">
															<!-- <span  aria-label="Descarga PDF" [inlineSVG]="'./assets/media/svg/files/pdf.svg'" cacheSVG="true" class="svg-icon svg-icon-3x svg-icon-success"></span> -->
															<div class="icon-circle bg-danger text-center align-middle pt-file-button">
																<fa-icon icon="file-pdf" class="fa-lg text-white"></fa-icon>
															</div>
														</a>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-column>

										<ngx-datatable-footer>
											<ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize" let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset" let-isVisible="isVisible">
												<div class="row" style="width: 100%">
													<div class="col-12 mb-2 ml-3 text-center mt-2">
														<datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'" [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="curPage" [size]="pageSize" [count]="rowCount" [hidden]="!(rowCount / pageSize > 1)" (change)="tableMobile.onFooterPage($event)"> </datatable-pager>
													</div>
													<div class="col-12 d-flex justify-content-center">
														<span class="mr-2 mt-3">Elementos por página</span>

														<ng-select [(ngModel)]="page.pageSize" [items]="page.pageSizes" [clearable]="false" (change)="setPageSize()" dropdownPosition="top" style="overflow: visible" appendTo="body">
															<option *ngFor="let option of page.pageSizes" [value]="option"></option>
														</ng-select>
														<span class="ml-4 mt-3"> Página {{ curPage }} de {{ getTotalPages(rowCount, pageSize) }} </span>
													</div>
												</div>
											</ng-template>
										</ngx-datatable-footer>
									</ngx-datatable>
									<!-- fin seccion tabla mobile-->
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
</div>
<ng-template #semaforo let-row="row">
	<app-semaforo-estado-dte [cesion]="row" [isCesion]="true"></app-semaforo-estado-dte>
</ng-template>
<ng-template #dteDetailModal let-d="dismiss" id="detail-modal">
	<div class="modal-content">
		<div class="modal-header">
			<div class="modal-wizard-label">
				<div class="modal-wizard-title">Detalle de Cesión</div>
				<div class="modal-wizard-desc">Detalles del documento seleccionado</div>
			</div>
		</div>
		<div class="modal-body">
			<div class="row form-group mx-auto" id="details-dte">
				<h4>Detalles Factura Folio N°{{ cesionToShow.folio }}</h4>
				<div class="col-12">
					<div class="row">
						<div class="col-4">
							<span class="d-block">Rut Cliente</span>
							<span class="d-block">Razon Social</span>
							<span class="d-block">Fecha Emision</span>
							<span *ngIf="cesionToShow.dte.fechaVencimiento != null" class="d-block">Fecha Vencimiento</span>
							<span *ngIf="cesionToShow.dte.formaPago != null" class="d-block">Forma Pago</span>
							<span class="d-block">Monto Total</span>
						</div>
						<div class="col-8">
							<span class="d-block text-right">{{
								cesionToShow.dte.rutReceptor
									? cesionToShow.dte.rutReceptorDv
									: "No
                                disponible"
							}}</span>
							<span class="d-block text-right">{{
								cesionToShow.dte.razonSocial
									? cesionToShow.dte.razonSocial
									: "No
                                disponible"
							}}</span>
							<span class="d-block text-right">{{ cesionToShow.dte.fecha | date : "dd/MM/yyyy" }}</span>
							<span *ngIf="cesionToShow.dte.fechaVencimiento != null" class="d-block text-right">{{ cesionToShow.dte.fechaVencimiento | date : "dd/MM/yyyy" }}</span>
							<span *ngIf="cesionToShow.dte.formaPago != null" class="d-block text-right">{{
								cesionToShow.dte.formaPago
									? cesionToShow.dte.formaPago
									: "No
                                disponible"
							}}</span>
							<span class="d-block text-right">{{ cesionToShow.montoTotal | currency : "$ " : "symbol" : "1.0-0" : "es" }}</span>
						</div>
					</div>
				</div>
			</div>
			<hr />
			<div class="row form-group mx-auto" id="details-dte">
				<h4>Persona Autorizada</h4>
				<div class="col-12">
					<div class="row">
						<div class="col-4">
							<span class="d-block">Rut</span>
							<span class="d-block">Nombre</span>
							<span class="d-block">Correo</span>
						</div>
						<div class="col-8">
							<span class="d-block text-right">{{
								cesionToShow.rutPersonaAutorizada
									? cesionToShow.rutPersonaAutorizada + "-" + cesionToShow.dvPersonaAutorizada
									: "No
                                disponible"
							}}</span>
							<span class="d-block text-right">{{
								cesionToShow.nombrePersonaAutorizada
									? cesionToShow.nombrePersonaAutorizada
									: "No
                                disponible"
							}}</span>
							<span class="d-block text-right">{{
								cesionToShow.correoPersonaAutorizada
									? cesionToShow.correoPersonaAutorizada
									: "No
                                disponible"
							}}</span>
						</div>
					</div>
				</div>
			</div>
			<hr />
			<div class="row form-group mx-auto" id="details-dte">
				<h4>Cesionario</h4>
				<div class="col-12">
					<div class="row">
						<div class="col-4">
							<span class="d-block">Rut</span>
							<span class="d-block">Razón Social</span>
							<span class="d-block">Correo</span>
						</div>
						<div class="col-8">
							<span class="d-block text-right">{{
								cesionToShow.detalles[0].cesionario.rutFormateado
									? cesionToShow.detalles[0].cesionario.rutFormateado
									: "No
                                disponible"
							}}</span>
							<span class="d-block text-right">{{
								cesionToShow.detalles[0].cesionario.razonSocial
									? cesionToShow.detalles[0].cesionario.razonSocial
									: "No
                                disponible"
							}}</span>
							<span class="d-block text-right">{{
								cesionToShow.detalles[0].cesionario.correo
									? cesionToShow.detalles[0].cesionario.correo
									: "No
                                disponible"
							}}</span>
						</div>
					</div>
				</div>
			</div>
			<hr />
			<div class="row form-group mx-auto" id="details-dte">
				<h4>Cesion</h4>
				<div class="col-12">
					<div class="row">
						<div class="col-4">
							<span class="d-block">Correo Deudor</span>
							<span class="d-block">Fecha Ultimo Vencimiento</span>
							<span class="d-block">Otras Condiciones</span>
							<span class="d-block">Monto Cesion</span>
							<!-- <span class="d-block">Declaración</span> -->
						</div>
						<div class="col-8">
							<span class="d-block text-right">{{
								cesionToShow.detalles[0].correoDeudor
									? cesionToShow.detalles[0].correoDeudor
									: "No
                                disponible"
							}}</span>
							<span class="d-block text-right">{{ cesionToShow.detalles[0].fechaUltimoVencimiento | date : "dd/MM/yyyy" }}</span>
							<span class="d-block text-right">{{
								cesionToShow.detalles[0].otrasCondiciones
									? cesionToShow.detalles[0].otrasCondiciones
									: "No
                                disponible"
							}}</span>
							<span class="d-block text-right">{{ cesionToShow.detalles[0].montoCesion | currency : "$ " : "symbol" : "1.0-0" : "es" }} </span>
							<!-- <span class="d-block text-right">{{cesionToShow.detalles[0].declaracionJurada}} </span> -->
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="row form-group mx-auto" id="cesionario-data">
                <h4>Cesionario</h4>
                <div class="col-12">
                    <div class="row">
                        <div class="col-4">Rut</div>
                        <div class="col-4">Razón Social</div>
                        <div class="col-4 text-right">correo</div>
                    </div>
                    <div class="row" id="details-cesionario">
                        <ng-container *ngFor="let cesionario of cesionToShow.detalles" class="col-12">
                                <div class="col-4" >
                                    <p>
                                        {{cesionToShow.detalles[0].cesionario.rutFormateado?cesionario.rutFormateado:"No disponible"}} 
                                    </p>
                                </div>
                                <div class="col-4">
                                    <p>
                                        {{cesionToShow.detalles[0].cesionario.razonSocial?cesionario.razonSocial:"No disponible"}}
                                    </p>
                                </div>
                                <div class="col-4">
                                    <p class="text-right">
                                        {{cesionToShow.detalles[0].cesionario.correo }}
                                    </p>
                                </div>
                        </ng-container>
                    </div>
                    <hr>
                    
                </div>
            </div> -->
		</div>
		<div class="modal-footer">
			<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
		</div>
	</div>
</ng-template>

<ng-template #tracesModal let-d="dismiss">
	<div class="modal-content">
		<div class="modal-header">
			<h5 class="modal-title" id="exampleModalLabel1">Trazabilidad</h5>
		</div>
		<form #TrazaForm="ngForm">
			<div class="modal-body">
				<div class="form-group row mx-auto" style="align-items: baseline">
					<label class="col-3 label-control" for="projectinput1">Documento:</label>
					<!-- <div class="col-9">
                   <input type="text" value="Factura Electronica N° {{ cesionToShow.folio }}" disabled name="ngModel" class="form-control" id="fecha" />
                </div> -->
				</div>
				<div class="form-group row mx-auto" style="align-items: baseline">
					<table class="table table-bordered" [hidden]="trazasCesionToShow.length == 0">
						<thead>
							<tr>
								<th>Fecha</th>
								<th>Descripción</th>
							</tr>
						</thead>
						<tbody>
							<tr *ngFor="let traza of trazasCesionToShow">
								<td>
									{{ traza.fecha | date : "dd/MM/yyyy HH:mm" }}
								</td>
								<td style="overflow-wrap: anywhere">{{ traza.descripcion }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
			<div class="modal-footer">
				<button type="button" class="btn btn-success" data-dismiss="modal" (click)="d('Cross click')">Volver</button>
			</div>
		</form>
	</div>
</ng-template>
